module.exports = __webpack_public_path__ + "img/page12.66ab777b.png";